// Chakra imports
import {
  Box,
  CircularProgress,
  Divider,
  Flex,
  FormControl,
  Icon,
  IconButton,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import IconBox from "components/icons/IconBox";
import { pesquisarTicketEmail } from "config/apis/requests";
import { IsEmpty } from "config/functions";
import { useEffect, useState } from "react";
import {
  MdOutlineAirplaneTicket,
  MdOutlineLink,
  MdRefresh,
} from "react-icons/md";

export default function Information(props: {
  dataUser: any;
  ticketUserNovo: any;
}) {
  const { dataUser, ticketUserNovo } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textGrayDataBg = useColorModeValue("secondaryGray.500", "navy.700");
  const textGrayBg = useColorModeValue("secondaryGray.900", "navy.700");
  const textGreenBg = useColorModeValue("green.500", "navy.300");
  const textYelBg = useColorModeValue("yellow.500", "navy.300");
  const redIcon = useColorModeValue("red.500", "white");
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [ticketDataUser, setTicketDataUser] = useState([]);
  const [pesquisar, setPesquisar] = useState(false);

  const iconBoxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const maskDateProtocolo = (dateString: string | number | Date) => {
    const date = new Date(dateString);
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();
    const hours = `0${date.getHours() - 3}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const colorStatus = (status: any) => {
    switch (status) {
      case "SOLVED":
        return (
          <Text color={textGreenBg} fontSize="sm" fontWeight="600">
            Finalizado
          </Text>
        );
      case "CLOSED":
        return (
          <Text color={textGreenBg} fontSize="sm" fontWeight="600">
            Finalizado
          </Text>
        );
      case "NEW":
        return (
          <Text color={textGrayBg} fontSize="sm" fontWeight="600">
            Chamado novo
          </Text>
        );
      case "OPEN":
        return (
          <Text color={textYelBg} fontSize="sm" fontWeight="600">
            Chamado pendente
          </Text>
        );
    }
  };

  const pesquisarTickets = () => {
    setPesquisar(true);
    setTimeout(() => {
      setPesquisar(false);
    }, 1000);
  };

  useEffect(() => {
    if (!IsEmpty(dataUser)) {
      pesquisarTicketEmail(dataUser.email).then(function (result) {
        if (!IsEmpty(result) || result < 400) {
          setTicketDataUser(result);
        }
      });
    }
  }, [dataUser, ticketUserNovo, pesquisar]);

  return (
    <FormControl>
      <Card mb="29px" {...dataUser} h={"400px"}>
        <Flex
          direction="row"
          mb="30px"
          ms="10px"
          justifyContent={"space-between"}
        >
          <Text fontSize="xl" color={textColorPrimary} fontWeight="bold">
            Histórico de Atendimento
          </Text>
          <IconButton
            aria-label="Transfer"
            borderRadius="50%"
            icon={
              <Icon
                as={MdRefresh}
                width="30px"
                height="30px"
                color={"brand.500"}
              />
            }
            onClick={() => pesquisarTickets()}
          />
        </Flex>

        <Divider mt="10px" />
        <Box
          position={"static"}
          overflowX="hidden"
          overflowY={ticketDataUser.length !== 0 ? "scroll" : "hidden"}
          maxW="100vw"
          h={
            pesquisar
              ? "50px"
              : ticketDataUser.length !== 0
              ? ticketDataUser.length < 5
                ? "165px"
                : "260px"
              : "45px"
          }
          whiteSpace="nowrap"
          pb="17px"
        >
          {pesquisar ? (
            <Flex justify="center" px="10px" pt="5px">
              <CircularProgress isIndeterminate color="green.300" size="30px" />
            </Flex>
          ) : !IsEmpty(ticketDataUser) ? (
            ticketDataUser
              .map((num: any) => (
                <Flex
                  justifyContent="center"
                  mt="10px"
                  alignItems="center"
                  w="100%"
                >
                  <IconBox
                    mr="12px"
                    h="42px"
                    w="42px"
                    bg={iconBoxBg}
                    icon={
                      <Icon
                        as={MdOutlineAirplaneTicket}
                        color={textYelBg}
                        w="20px"
                        h="18px"
                      />
                    }
                  />
                  <Flex direction="column" align="start" me="auto">
                    <Text
                      color={textGrayDataBg}
                      fontSize="sm"
                      me="6px"
                      fontWeight="700"
                    >
                      Criado em {maskDateProtocolo(num.created_at)}
                    </Text>
                    <Text color={textGrayBg} fontSize="sm" fontWeight="500">
                      Protocolo: {num.id}
                    </Text>
                    {colorStatus(num.status)}
                  </Flex>
                  <Flex
                    direction="column"
                    align="center"
                    justify="space-between"
                  >
                    <Text
                      ms="auto"
                      color={textColor}
                      fontSize="sm"
                      fontWeight="300"
                      mr="10px"
                    >
                      <a
                        href={
                          "https://sac-billingpay.zendesk.com/agent/tickets/" +
                          num.id
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <IconButton
                          aria-label="2"
                          px="0px"
                          variant="no-hover"
                          bg="transparent"
                        >
                          <Icon
                            as={MdOutlineLink}
                            h="24px"
                            w="24px"
                            color="green"
                          />
                        </IconButton>
                      </a>
                    </Text>
                    <Text
                      ms="auto"
                      color={textColor}
                      fontSize="lg"
                      me="8px"
                      fontWeight="700"
                    ></Text>
                  </Flex>
                </Flex>
              ))
              .sort()
          ) : (
            <Text
              fontSize="md"
              color={redIcon}
              fontWeight="500"
              align={"center"}
            >
              Sem dados disponíveis para pesquisa.
            </Text>
          )}
        </Box>
        <Divider mt="10px" />
      </Card>
    </FormControl>
  );
}
